<template>
  <div>
    <div class="px-4 py-2 rounded-xl light2 between">
      <div class="text-xs text-slate-500 dark:text-slate-400 uppercase">
        {{ $t("fixed.code") }}
        <span
          class="text-base text-slate-700 dark:text-white tracking-wider mx-2"
          >{{ order.code }}</span
        >
      </div>
      <div>{{ $time(order.time) }}</div>
    </div>
    <div
      v-for="product in order.products"
      :key="product.id"
      class="w-full h-24 between relative"
      dir="rtl"
    >
      <div class="w-9/12 p-2">
        <div
          @click="$router.push(`/product/${product.id}`)"
          dir="auto"
          class="truncate"
        >
          {{ product.name }}
        </div>
        <div dir="auto" class="my-2">
          <span class="text-sm text-slate-500 dark:text-slate-400">{{
            $t("fixed.size")
          }}</span>
          <span class="text-sm mx-2 uppercase">{{
            product.selectedSize ? product.selectedSize : $t("fixed.standard")
          }}</span>
        </div>
        <div :dir="$doc('html').dir == 'rtl' ? 'ltr' : 'rtl'" class="between">
          <div dir="rtl" class="start">
            <h6 class="text-xs mx-2">DZD</h6>
            <h1 class="font-medium">
              {{ product.quantity * product.price }}
            </h1>
          </div>
          <div dir="auto" class="w-5/12">
            <span class="text-sm text-slate-500 dark:text-slate-400">
              {{ $t("fixed.quantity") }}
            </span>
            <span class="text-sm mx-2">
              {{ product.quantity }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="w-3/12 min-h-full bg rounded-xl mr-1"
        :style="`background-image: url(${product.images[0]})`"
      ></div>
    </div>
    <div class="h-24"></div>
    <div dir="ltr" class="bottom between w-full light">
      <div class="w-6/12 light2 p-2 rounded-xl m-auto">
        <div class="start">
          <h1 class="tracking-wider font-medium m-auto">
            {{
              order.products
                ? order.products.reduce((a, b) => {
                    return a + b.price * b.quantity;
                  }, 0)
                : 0
            }}
          </h1>
          <h6 class="text-xs mx-2">DZD</h6>
        </div>
      </div>
      <button-app
        @action="cancel()"
        svg="x"
        :text="$t('fixed.cancel')"
        theme="btnD w-5/12"
      />
    </div>
    <div v-if="alert" class="alert-back">
      <div class="alert-front">
        <div class="text-title uppercase">{{ $t(alert.title) }}</div>
        <div class="p-8 g-center">
          <svg-app :type="alert.svg" theme="w-12" />
        </div>
        <a :href="alert.link" class="text-dis">{{ $t(alert.dis) }}</a>
        <div class="text-sub-1">
          {{ $t(alert.subDis, { code: this.code }) }}
        </div>
        <div v-if="alert.action != false" dir="ltr" class="between pt-4">
          <button-app
            v-if="!alert.process"
            @action="alert = false"
            :text="$t('fixed.no')"
            svg="x"
          />
          <button-app
            @action="yes()"
            :text="$t('fixed.yes')"
            :svg="alert.process ? 'process' : 'done'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import buttonApp from "@/components/buttonApp.vue";
import svgApp from "@/components/svgApp.vue";
import { db } from "@/assets/db";

export default {
  components: { buttonApp, svgApp },
  data() {
    return {
      id: this.$route.params.id,
      alert: null,
      order: [],
    };
  },
  async created() {
    this.order = await db.orders.get({ id: this.id });
  },
  methods: {
    cancel() {
      this.alert = {
        title: "fixed.cancel",
        svg: "bag",
        dis: "fixed.alert.cancel",
        process: false,
      };
    },
    yes() {
      this.alert.process = true;
      db.orders.delete(this.id).then(() => {
        setTimeout(() => {
          this.alert = {
            title: "fixed.cancel",
            svg: "done",
            dis: "fixed.alert.canceled",
            action: false,
          };
        }, 2000);
      });
    },
  },
};
</script>

<style></style>
